function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "F1_70");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "Main-nav-/-1440-",
  transform: "translate(-71.000000, -70.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nav"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "primary-nav",
  transform: "translate(0.000000, 46.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Bar"
}, /*#__PURE__*/React.createElement("g", {
  id: "F1_70",
  transform: "translate(71.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill-1",
  fill: "#FFF",
  d: "M0,24.9996429 L16.778,7.8797449 C22.854,1.67923469 26.141,0.509846939 37.582,0.509846939 L78.679,0.509846939 L70.3385,8.85780612 L39.3715,8.85780612 C30.9345,8.85780612 28.7615,9.5430102 24.6075,13.7496429 L13.518,24.9996429 L0,24.9996429 Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-3",
  fill: "#FFF",
  d: "M40.20265,11.1733163 C31.76565,11.1733163 30.13565,11.5646429 26.33315,15.4452551 L17.03315,24.9998469 L29.56065,24.9998469 L32.53265,21.9018878 C34.29015,20.0432143 35.02565,19.5865816 39.21215,19.5865816 L59.69615,19.5865816 L68.03715,11.1733163 L40.20265,11.1733163 Z"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  fill: "#FFF",
  points: "81.619 .51 57.619 25 71.84 25 95.936 .51"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-7",
  fill: "#FFF",
  points: "80.761 20.917 84 20.917 84 21.533 82.728 21.533 82.728 24.999 82.028 24.999 82.028 21.533 80.761 21.533"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-9",
  fill: "#FFF",
  points: "84.648 20.917 85.635 20.917 86.738 24.112 86.749 24.112 87.825 20.917 88.8 20.917 88.8 24.999 88.133 24.999 88.133 21.848 88.121 21.848 87.013 24.999 86.435 24.999 85.326 21.848 85.315 21.848 85.315 24.999 84.648 24.999"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-12",
  fill: "#FFF",
  d: "M128.884933,10.574949 C130.089776,11.7897449 130.089776,13.7586224 128.884933,14.9734184 C127.680089,16.1882143 125.726836,16.1882143 124.521993,14.9734184 C124.097945,14.5458673 123.826716,14.0244388 123.701222,13.4759694 L120.813342,16.3871939 C121.090137,16.8397449 121.420571,17.2678061 121.81021,17.6606633 C124.499222,20.3718878 128.859631,20.3718878 131.549655,17.6606633 C134.239173,14.9484184 134.239173,10.5519898 131.549655,7.8402551 C128.859631,5.12852041 124.499222,5.12852041 121.81021,7.8402551 C121.778836,7.87137755 121.751005,7.90505102 121.721149,7.93617347 L121.721149,7.93566327 L104.821969,24.9744388 L110.246041,24.9718878 L120.157029,14.9790306 L120.157029,14.9795408 L124.492643,10.607602 C124.50327,10.5968878 124.511366,10.5856633 124.521993,10.574949 C125.726836,9.36015306 127.680089,9.36015306 128.884933,10.574949"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-14",
  fill: "#FFF",
  d: "M135.236952,4.09673469 C130.581024,-0.597653061 123.086807,-0.680306122 118.326639,3.84265306 L97.3499157,24.9712245 L102.773988,24.9686735 C102.773988,24.9686735 120.646759,6.92887755 120.759096,6.81612245 C124.011819,3.5355102 129.286614,3.5355102 132.539843,6.81612245 C135.793072,10.0962245 135.793072,15.4145918 132.539843,18.6941837 C129.286614,21.9742857 124.011819,21.9742857 120.759096,18.6941837 C120.377048,18.3089796 120.040542,17.8957143 119.74806,17.4610204 L117.018566,20.2135714 C117.336349,20.629898 117.683482,21.0314286 118.061988,21.4135714 C122.804952,26.1952041 130.493988,26.1952041 135.236952,21.4135714 C139.97941,16.6314286 139.97941,8.87836735 135.236952,4.09673469"
}), /*#__PURE__*/React.createElement("path", {
  id: "Fill-16",
  fill: "#FFF",
  d: "M117.333364,2.77984694 C118.301388,1.85994898 119.38428,1.0997449 120.546111,0.50994898 L100.002545,0.50994898 L100.002545,4.36352041 L115.760641,4.36352041 L117.333364,2.77984694 Z"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-18",
  fill: "#FFF",
  points: "114.308 5.827 100.002 5.827 100.002 9.682 110.481 9.682"
}))))))));

var SvgF1Logo = function SvgF1Logo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 25,
    viewBox: "0 0 139 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgF1Logo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f1_logo.932175f7.svg";
export { ForwardRef as ReactComponent };